/* Regular expression pattern for validating email addresses in a specific format commonly used in Braze email marketing platform. */
/* "Display Name <email@address.com>" */
export const BRAZE_EMAIL_VALIDATION =
    /^([^<]+)\s<([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>$/;
